// extracted by mini-css-extract-plugin
module.exports = {"OrderItemImage":"styles_OrderItemImage__D45yO"};